import { Chat } from "@mui/icons-material";
import { Box, Fab, Fade } from "@mui/material";
import { useCallback, useState } from "react";
import ChatPanel from "./components/ChatPanel";
import ExitChatAlert from "./components/ExitChatAlert";

const KnowledgeAssistant = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [exitChat, setExitChat] = useState<boolean>(false);

  const handleChat = useCallback(() => {
    if (open) {
      setExitChat(true);
      return;
    }
    setOpen(true);
  }, [open]);

  const handleCancelExit = useCallback(() => {
    setExitChat(false);
  }, []);

  const handleConfirmExit = useCallback(() => {
    setExitChat(false);
    setOpen(false);
  }, []);

  return (
    <Box sx={{ position: "fixed", bottom: 100, right: 24, zIndex: 1300 }}>
      <Fade in={open} timeout={500} unmountOnExit>
        <div>
          <ChatPanel onClose={handleChat} />
        </div>
      </Fade>
      <Fab
        color="primary"
        onClick={handleChat}
        sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 1300 }}
      >
        <Chat />
      </Fab>
      <ExitChatAlert
        open={exitChat}
        onConfirm={handleConfirmExit}
        onCancel={handleCancelExit}
      />
    </Box>
  );
};

export default KnowledgeAssistant;
